import features from './features/food-benefit.features';
import components from './components/food-benefit.components';
import common from './common/food-benefit.common';

let foodBenefitModule = angular.module('food-benefit', [
  common,
  features,
  components,
])

  .config(($translatePartialLoaderProvider) => {
    'ngInject';

    $translatePartialLoaderProvider.addPart('food-benefit.module');
  })

  .name;

export default foodBenefitModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/food-benefit.module.js